export default __webpack_public_path__ + "static/media/kv_text_m.e6a1055a.png";